const trustItems = [
  { icon: "ri-award-line", label: "AIA Licensed Architect" },
  { icon: "ri-building-2-line", label: "Residential & Commercial Design" },
  { icon: "ri-time-line", label: "40+ Years of Experience" },
  { icon: "ri-medal-line", label: "CCIM Designation" },
  { icon: "ri-shield-check-line", label: "Licensed in Texas Since 1984" },
  { icon: "ri-map-pin-2-line", label: "Serving Greater Houston" },
];

export default function TrustBar() {
  return (
    <section className="bg-stone-900 py-6 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {trustItems.map((item, i) => (
            <div key={i} className="flex items-center gap-2.5">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${item.icon} text-amber-400 text-base`}></i>
              </div>
              <span
                className="text-white/70 text-xs tracking-widest uppercase whitespace-nowrap"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {item.label}
              </span>
              {i < trustItems.length - 1 && (
                <span className="hidden lg:block w-px h-3 bg-white/20 ml-5"></span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
